<div class="e-filing-filters">
    <p-toolbar class="filter-toolbar">
        <p-floatlabel
            variant="on"
            style="min-width: 160px">
            <p-select
                [options]="parentCompanyOptions"
                [(ngModel)]="parentCompany"
                optionLabel="label"
                dataKey="name"
                (onChange)="clearFilters(); applyFilters()"
                [fluid]="true"></p-select>
            <label>Parent Company</label>
        </p-floatlabel>
        <p-floatlabel
            variant="on"
            style="min-width: 100px">
            <p-select
                [options]="clientOptions"
                [(ngModel)]="clientFilter"
                optionLabel="label"
                (onChange)="applyFilters()"
                [fluid]="true"></p-select>
            <label>Client</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input
                pInputText
                id="searchTerm"
                [(ngModel)]="searchFilter"
                (ngModelChange)="applyFilters()" />
            <label for="searchTerm">Search</label>
        </p-floatlabel>

        <!--		<p-floatlabel-->
        <!--			variant="on"-->
        <!--			style="min-width: 125px">-->
        <!--			<p-select-->
        <!--				[options]="assignedToOptions"-->
        <!--				[(ngModel)]="assignedToFilter"-->
        <!--				optionLabel="label"-->
        <!--				(onChange)="applyFilters()"-->
        <!--				styleClass="w-full"></p-select>-->
        <!--			<label>Assigned To</label>-->
        <!--		</p-floatlabel>-->

        <p-floatlabel
            variant="on"
            style="min-width: 125px">
            <p-select
                [options]="requisitionerOptions"
                [(ngModel)]="requisitionerFilter"
                optionLabel="label"
                (onChange)="applyFilters()"
                [filter]="true"
                filterBy="value"
                [fluid]="true"></p-select>
            <label>Requisitioner</label>
        </p-floatlabel>

        <!--		removed until non-open ns invoices are loaded into application-->
        <!--        <p-floatlabel-->
        <!--            variant="on"-->
        <!--            style="min-width: 120px">-->
        <!--            <p-select-->
        <!--                class="w-full"-->
        <!--                [options]="nsStatusOptions"-->
        <!--                [(ngModel)]="nsStatusFilter"-->
        <!--                optionLabel="label"-->
        <!--                (onChange)="applyFilters()"></p-select>-->
        <!--            <label>NS Status</label>-->
        <!--        </p-floatlabel>-->

        <p-floatlabel
            variant="on"
            style="min-width: 130px">
            <p-select
                [options]="oiStatusOptions"
                [(ngModel)]="selectedOiStatus"
                optionLabel="label"
                (onChange)="applyFilters()"
                [fluid]="true"></p-select>
            <label>OI Status</label>
        </p-floatlabel>

        <p-floatlabel
            variant="on"
            style="min-width: 130px">
            <p-select
                [options]="otStatusOptions"
                [(ngModel)]="selectedOtStatus"
                optionLabel="label"
                (onChange)="applyFilters()"
                [fluid]="true"></p-select>
            <label>OT Status</label>
        </p-floatlabel>

        <p-floatlabel
            variant="on"
            style="min-width: 160px">
            <p-multiSelect
                [options]="errorStatusOptions"
                [(ngModel)]="selectedErrorStatuses"
                optionLabel="label"
                optionValue="value"
                (onChange)="applyFilters()"
                [showToggleAll]="false"
                [filter]="false"
                [fluid]="true"></p-multiSelect>
            <label>Validation Level</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-datepicker
                [(ngModel)]="startDateFilter"
                inputId="startDateFilter"
                (onSelect)="applyFilters()"
                (onClearClick)="applyFilters()"
                [iconDisplay]="'input'"
                [showButtonBar]="true"
                [showIcon]="true"></p-datepicker>
            <label for="startDateFilter">Start Date</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-datepicker
                [(ngModel)]="endDateFilter"
                inputId="endDateFilter"
                (onSelect)="applyFilters()"
                (onClearClick)="applyFilters()"
                [iconDisplay]="'input'"
                [showButtonBar]="true"
                [showIcon]="true"></p-datepicker>
            <label for="endDateFilter">End Date</label>
        </p-floatlabel>

        <p-button
            (onClick)="clearFilters()"
            [styleClass]="'embark-bg-blue opacity-70 ml-3'"
            [raised]="true"
            [label]="'Clear Filters'"></p-button>

        <p-button
            (onClick)="exportMenu.toggle($event)"
            [styleClass]="'p-button-secondary ml-3'"
            [raised]="true"
            [icon]="'pi pi-chevron-down'"
            [label]="'Export'"
            iconPos="right"></p-button>

        <div class="flex justify-content-center">
            <p-menu
                #exportMenu
                [popup]="true"
                [model]="exportButtons()"
                styleClass="w-full md:w-15rem">
                <ng-template
                    pTemplate="item"
                    let-item>
                    <a
                        pRipple
                        class="flex align-items-center p-menuitem-link ml-3 mr-3 mb-2 mb-2 border-round-lg pointer"
                        [style.background-color]="item.bgColor"
                        (click)="item.command($event)">
                        <span
                            class="col-9"
                            [style]="{ color: embarkColors['black75'] }">
                            {{ item.label }}
                            <span [class]="item.icon"></span>
                        </span>
                    </a>
                </ng-template>
            </p-menu>
        </div>
        @if (parentCompany != null && !isLoading()) {
            @if (!refreshLoading()) {
                <p-button
                    (onClick)="refresh()"
                    [styleClass]="'p-button-secondary ml-3'"
                    [raised]="true"
                    [icon]="'pi pi-refresh'"
                    pTooltip="Refresh invoices"
                    label="Refresh Invoices"
                    tooltipPosition="bottom"></p-button>
            } @else {
                <app-embark-spinner
                    [size]="'2'"
                    [strokeWidth]="'6'"></app-embark-spinner>
            }
        }
    </p-toolbar>
</div>
@if (selectedCount() > 0) {
    <div class="e-filing-filters">
        <p-toolbar class="filter-toolbar">
            <span style="padding-right: 10px">
                <h3>{{ selectedCount() }} Selected</h3>
            </span>
            <p-button
                (onClick)="submitInvoices.emit()"
                [styleClass]="'embark-bg-green opacity-70 ml-3'"
                [raised]="true"
                [icon]="'pi pi-play'"
                [label]="'Submit Invoices'"></p-button>
            <p-button
                (onClick)="unselectInvoices()"
                [styleClass]="'p-button-secondary ml-3'"
                [raised]="true"
                [label]="'Clear Selection'"
                [icon]="'pi pi-times'"></p-button>
        </p-toolbar>
    </div>
}
